import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { settingsApi, type MailRecipients } from "../../api/endpoints";

export function useRecipients() {
  return useQuery({
    queryKey: ["settings", "recipients"],
    queryFn: () => settingsApi.getRecipients().then((r) => r.data),
  });
}

export function useUpdateRecipients() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: MailRecipients) => settingsApi.setRecipients(data).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["settings", "recipients"] }),
  });
}
